import CryptoJS from 'crypto-js';

export const decryptLecacyLargeFile = async (file, key) => {
    const reader = new FileReader();
    return new Promise((resolve) => {
        reader.onload = () => {
        const { keytosend, iv } = getIVandKey(key);
        const decrypted = CryptoJS.AES.decrypt(reader.result, keytosend, {
            mode: CryptoJS.mode.CBC,
            iv: iv
        }); 
        const typedArray = convertWordArrayToUint8Array(decrypted); 
        const fileDecrypted = new Blob([ typedArray ], {
            type: file.type
        }); 
        const blobUrl = window.URL.createObjectURL(fileDecrypted);
        resolve({ blobUrl, blob: fileDecrypted });
        };
        reader.readAsText(file);
    });
 }
  export const arrayBufferToWordArray = (ab) => {
   const i8a = new Uint8Array(ab);
   const a = [];
   for (let i = 0; i < i8a.length; i += 4) {
     a.push(
       (i8a[ i ] << 24) |
         (i8a[ i + 1 ] << 16) |
         (i8a[ i + 2 ] << 8) |
         (i8a[ i + 3 ])
     );
   }
   return CryptoJS.lib.WordArray.create(a, i8a.length);
 }